class TextToggle extends HTMLElement {
  constructor() {
    super();
    this.trigger;
  }

  connectedCallback() {
    this.trigger = this.querySelector('button');

    this.trigger.addEventListener('click', this.handleToggle.bind(this))
  }

  handleToggle() {
    this.classList.toggle('is-open');
  }
}

customElements.define('text-toggle', TextToggle);
